import { createContext, ReactNode, useEffect, useState } from 'react'
import { GET } from '../services/api'
import { useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';


type ProductType = {
  id: number;
  name: string;
  code: string;
}

type AdditionalType = {
    id: number;
    max?: number;
    product: ProductType
}

export type AdditionalListType = {
    id: number;
    name: string;
    description: string;
    type: string;
    max: number;
    required: string;
    products: AdditionalType[];
    additionals: AdditionalType[];
    qtdProducts: number;
    qtdAdditionals: number;
    totalAssociated: number;
}

type AdditionalListResponseType = {
    id: number;
    name: string;
    type: string;
    max: number;
    required: number;
    description: string;
    products: AdditionalType[];
    additionals: AdditionalType[];
    totalAssociated: number;
}

type ReturnData = {
    data: any
    success: boolean
}

type AdditionalContextData = {
    getAdditionals: (fromApi?: boolean) => Promise<ReturnData>
    getAdditionalId: (id: number) => Promise<ReturnData>
    getAdditionalIdEditPage: (id: number) => Promise<ReturnData>
    getAdditionalByFatherId: (fatherId: number,fromApi?: boolean) => Promise<ReturnData>
    getAdditionalIdAssociatePage: (fatherId: number,fromApi?: boolean) => Promise<ReturnData>
}

type AdditionalContextProvider = {
    children: ReactNode
}

export const AdditionalContext = createContext({} as AdditionalContextData)

const AdditionalProvider = ({ children }: AdditionalContextProvider) => {

    const [additionals, setAdditionals] = useState<AdditionalListType[]>([])

    const getAdditionalId = async (id: number) => {
        if(additionals.length > 0) {
            const additionalFilter = additionals.filter((add) => add.id === id)
            return {
                data: additionalFilter,
                success: true
            }
        }
        else {
            try {
                const newAdditionals = await GET(`optional/${id}`)
                if(newAdditionals && newAdditionals.success && newAdditionals.data){
                    const newAdditionalsFormated:AdditionalListType[] = newAdditionals.data.map((add: AdditionalListResponseType) => ({
                        id: add.id,
                        name: add.name,
                        description: add.description,
                        type: add.type,
                        max: add.max ? add.max : 0,
                        required: add.required ? add.required.toString() : '0',
                        products: add.products,
                        additionals: add.additionals,
                        qtdProducts: add.products.length,
                        qtdAdditionals: add.additionals.length,
                        totalAssociated: add.totalAssociated,
                    }))
                    const additionalFilter = newAdditionalsFormated.filter((add) => add.id === id)
                    return {
                        data: additionalFilter,
                        success: true
                    }
                } else {
                    return {
                        data: null,
                        success: false
                    }
                }
            } catch(e){
                console.log(e)
                return {
                    data: e,
                    success: false
                }
            }
        }
    }

    const getAdditionalIdEditPage = async (id: number) => {
        if(additionals.length > 0) {
            const additionalFilter = additionals.filter((add) => add.id === id)
            return {
                data: additionalFilter,
                success: true
            }
        }
        else {
            try {
                const newAdditionals = await GET(`optional/${id}/edit-page`)
                if(newAdditionals && newAdditionals.success && newAdditionals.data){
                    const newAdditionalsFormated:AdditionalListType[] = newAdditionals.data.map((add: AdditionalListResponseType) => ({
                        id: add.id,
                        name: add.name,
                        description: add.description,
                        type: add.type,
                        max: add.max ? add.max : 0,
                        required: add.required ? add.required.toString() : '0',
                        products: add.products,
                        additionals: add.additionals,
                        totalAssociated: add.totalAssociated,
                    }))
                    const additionalFilter = newAdditionalsFormated.filter((add) => add.id === id)
                    return {
                        data: additionalFilter,
                        success: true
                    }
                } else {
                    return {
                        data: null,
                        success: false
                    }
                }
            } catch(e){
                console.log(e)
                return {
                    data: e,
                    success: false
                }
            }
        }
    }

    const getAdditionalIdAssociatePage = async (id: number) => {
        if(additionals.length > 0) {
            const additionalFilter = additionals.filter((add) => add.id === id)
            return {
                data: additionalFilter,
                success: true
            }
        }
        else {
            try {
                const newAdditionals = await GET(`optional/${id}/associate-page`)
                if(newAdditionals && newAdditionals.success && newAdditionals.data){
                    const newAdditionalsFormated:AdditionalListType[] = newAdditionals.data.map((add: AdditionalListResponseType) => ({
                        id: add.id,
                        name: add.name,
                        description: add.description,
                        type: add.type,
                        max: add.max ? add.max : 0,
                        required: add.required ? add.required.toString() : '0',
                        products: add.products,
                        additionals: add.additionals,
                        totalAssociated: add.totalAssociated,
                    }))
                    const additionalFilter = newAdditionalsFormated.filter((add) => add.id === id)
                    return {
                        data: additionalFilter,
                        success: true
                    }
                } else {
                    return {
                        data: null,
                        success: false
                    }
                }
            } catch(e){
                console.log(e)
                return {
                    data: e,
                    success: false
                }
            }
        }
    }

    const getAdditionalByFatherId = async (fatherId: number, fromApi?:boolean) => {
        if(additionals.length > 0 && !fromApi) {
            const additionalFilter = additionals.filter((add) => {
                let shouldReturn = false;
                if(add.products.find((pd) => pd.product.id === fatherId)){
                    shouldReturn = true
                }
                return shouldReturn
            })
            return {
                data: additionalFilter,
                success: true
            }
        }
        else {
            try {
                const newAdditionals = await GET(`optional/father/${fatherId}`)
                if(newAdditionals && newAdditionals.success && newAdditionals.data){
                    const newAdditionalsFormated:AdditionalListType[] = newAdditionals.data.map((add: AdditionalListResponseType) => ({
                        id: add.id,
                        name: add.name,
                        description: add.description,
                        type: add.type,
                        max: add.max ? add.max : 0,
                        required: add.required ? add.required.toString() : '0',
                        products: add.products,
                        additionals: add.additionals,
                        qtdProducts: add.products.length,
                        qtdAdditionals: add.additionals.length,
                        totalAssociated: add.totalAssociated,
                    }))
                    return {
                        data: newAdditionalsFormated,
                        success: true
                    }
                } else {
                    return {
                        data: null,
                        success: false
                    }
                }
            } catch(e){
                console.log(e)
                return {
                    data: e,
                    success: false
                }
            }
        }
    }

    const getAdditionals = async (fromApi?: boolean) => {
        if(additionals.length > 0 && !fromApi) {
            return {
                data: additionals,
                success: true
            }
        }
        else {
            try {
                const newAdditionals = await GET('optional')
                if(newAdditionals && newAdditionals.success && newAdditionals.data){
                    const newAdditionalsFormated = newAdditionals.data.map((add: AdditionalListResponseType) => ({
                        id: add.id,
                        name: add.name,
                        description: add.description,
                        type: add.type,
                        max: add.max ? add.max : 0,
                        required: add.required ? add.required.toString() : '0',
                        products: add.products,
                        additionals: add.additionals,
                        qtdProducts: add.products.length,
                        qtdAdditionals: add.additionals.length,
                        totalAssociated: add.totalAssociated,
                    }))
                    setAdditionals(newAdditionalsFormated)
                    return {
                        data: newAdditionalsFormated,
                        success: true
                    }
                } else {
                    return {
                        data: null,
                        success: false
                    }
                }
            } catch(e){
                console.log(e)
                return {
                    data: e,
                    success: false
                }
            }
        }
    }

    return (
        <AdditionalContext.Provider
            value={{
                getAdditionals,
                getAdditionalId,
                getAdditionalByFatherId,
                getAdditionalIdEditPage,
                getAdditionalIdAssociatePage
            }}
        >
            {children}
        </AdditionalContext.Provider>
    )
}

export default AdditionalProvider